module.exports = __webpack_public_path__ + "static/img/cs1.dbef286.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhsh/cs1.png
// module id = 4++B
// module chunks = 13